import moment from 'moment'

export const scheduleDateFormat = (string) =>
  moment(string).format('MM/DD/YYYY')

export const scheduleTimeFormat = (string) => moment(string).format('HH:mm')
